import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000';

const authService = {
    async register(userData) {
        try {
            // Axios automatically sets Content-Type to multipart/form-data when data is FormData
            const response = await axios.post(`${API_URL}/auth/register`, userData);
            return response.data;
        } catch (error) {
            throw error.response?.data?.detail || 'Registration failed';
        }
    },

    async login(email, password) {
        try {
            const params = new URLSearchParams();
            params.append('username', email);
            params.append('password', password);

            // Step 1: get the token
            const response = await axios.post(`${API_URL}/auth/token/`, params, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            });

            if (response.data.access_token) {
                const token = response.data.access_token;
                const authHeader = { Authorization: `Bearer ${token}` };

                // Step 2: fetch user profile (single call after token)
                const userResponse = await axios.get(`${API_URL}/users/me/`, { headers: authHeader });

                const fullUser = {
                    ...response.data,   // access_token, token_type
                    ...userResponse.data // id, email, full_name, role, etc.
                };

                localStorage.setItem('user', JSON.stringify(fullUser));
                return fullUser;
            }
            return response.data;
        } catch (error) {
            throw error.response?.data?.detail || 'Login failed';
        }
    },

    logout() {
        localStorage.removeItem('user');
    },

    getCurrentUser() {
        return JSON.parse(localStorage.getItem('user'));
    }
};

export default authService;
